import React, { useMemo } from 'react';
import { isNil } from 'lodash';
import cx from 'classnames';
import DraggableTabs from './DraggableTabs';
import './Tabs.scss';

const CustomTabs = (props) => {
  const {
    className,
    tabPosition = 'top',
    type = 'card',
    list,
    onChange,
    activeKey,
    canDrag = false,
    onDelete,
    onAdd,
    ...res
  } = props;

  // list를 antd v5 items 형식으로 변환 (메모이제이션)
  const items = useMemo(() => {
    return list.map((item, index) => ({
      key: String(isNil(item.id) ? index : item.id),
      label: item.title,
      children: item.content,
      disabled: item.disabled,
      forceRender: item.forceRender,
    }));
  }, [list]);

  let currentKey = {};
  if (!isNil(activeKey)) currentKey.activeKey = activeKey.toString();

  // left position tabs에서는 불안정한 기능들 비활성화
  const leftTabsProps =
    tabPosition === 'left'
      ? {
          indicator: { size: 0 }, // ink-bar 비활성화
          animated: false, // 애니메이션 비활성화
          moreIcon: null, // overflow 계산 비활성화 (nav-operations-hidden 토글 방지)
        }
      : {};

  return (
    <DraggableTabs
      className={cx(className)}
      type={type}
      tabPosition={tabPosition}
      list={list}
      items={items}
      {...currentKey}
      canDrag={canDrag}
      {...leftTabsProps}
      onEdit={(targetKey, action) => (action === 'remove' ? onDelete(Number(targetKey)) : onAdd(Number(targetKey)))}
      onChange={(key) => onChange && onChange(Number(key))}
      {...res}
    />
  );
};

export default CustomTabs;
